import { render } from "./MainNav.vue?vue&type=template&id=fea3dd44"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"

import "./MainNav.vue?vue&type=style&index=0&id=fea3dd44&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__